import React, { ComponentProps } from 'react';

import { Wave1, Wave2 } from './styles';

interface IWavesProps extends React.SVGAttributes<SVGElement> {
  variant?: 'primary' | 'success' | 'error' | 'pending';
  animate?: boolean;
}

const Waves: React.FC<IWavesProps> = ({
  variant = 'primary',
  animate = true,
  ...props
}) => {
  return (
    <svg
      width={541}
      height={218}
      viewBox="0 0 541 218"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Wave1
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.1655 218C108.453 218 130.229 196.988 169.78 196.988C209.331 196.988 223.89 218 272 218C320.11 218 321.997 196.988 371.204 196.988C420.411 196.988 429.883 218 479.764 218C529.645 218 544 196.988 544 196.988L544 3.22992e-05L1.90582e-05 -1.52588e-05C1.90582e-05 -1.52588e-05 1.83695e-06 196.988 1.83695e-06 196.988C1.83695e-06 196.988 43.8781 218 76.1655 218Z"
        fill={`url(#waves1-${variant})`}
        animate={animate}
      />
      <Wave2
        opacity="0.3"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.1655 193.959C108.453 193.959 130.229 209.986 169.78 209.986C209.331 209.986 223.89 193.959 272 193.959C320.11 193.959 321.997 209.986 371.204 209.986C420.411 209.986 429.883 193.959 479.764 193.959C529.645 193.959 544 209.986 544 209.986L544 111.678L8.59435e-06 111.678C8.59435e-06 111.678 0 209.986 0 209.986C0 209.986 43.8781 193.959 76.1655 193.959Z"
        fill={`url(#waves2-${variant})`}
        animate={animate}
      />
      <defs>
        <linearGradient
          id="waves1-primary"
          x1="68.9308"
          y1={218}
          x2="68.9308"
          y2="55.246"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEE7FD" />
          <stop offset={1} stopColor="#FAFAFA" />
        </linearGradient>
        <linearGradient
          id="waves2-primary"
          x1="68.9308"
          y1="209.986"
          x2="68.9308"
          y2="136.592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEE7FD" />
          <stop offset={1} stopColor="#FAFAFA" />
        </linearGradient>
        <linearGradient
          id="waves1-error"
          x1="311.5"
          y1="78.2437"
          x2="311.5"
          y2="479.965"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8382" stopOpacity={0} />
          <stop offset="0.9999" stopColor="#FF8382" />
          <stop offset={1} stopColor="#FF8382" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="waves2-error"
          x1="270.5"
          y1="441.106"
          x2="270.5"
          y2="129.665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8382" />
          <stop offset={1} stopColor="#FF8382" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="waves1-success"
          x1={272}
          y1={218}
          x2={272}
          y2="2.3779e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4EBDB" />
          <stop offset={1} stopColor="#C4EBDB" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="waves2-success"
          x1={272}
          y1="209.986"
          x2={272}
          y2="111.678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C4EBDB" />
          <stop offset={1} stopColor="#C4EBDB" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="waves1-pending"
          x1={272}
          y1={218}
          x2={272}
          y2="2.3779e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDBDBD" stopOpacity="0.7" />
          <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="waves2-pending"
          x1={272}
          y1="209.986"
          x2={272}
          y2="111.678"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BDBDBD" stopOpacity="0.7" />
          <stop offset={1} stopColor="#BDBDBD" stopOpacity={0} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export type WavesProps = ComponentProps<typeof Waves>;
export default Waves;
